<template>
  <div
    v-loading.fullscreen.lock="mainLoader"
    class="gs-profile-page body__content"
  >
    <div class="back-to-search-section">
      <div class="container">
        <router-link
          v-if="showBackToSearch"
          :to="{ name: 'Members', params: { sortBy: 'Organisation' } }"
          class="back-to-search-link"
        >
          <span>
            <svg-white-arrow-left class="mr-1"></svg-white-arrow-left>Back to
            search
          </span>
        </router-link>
        <a
          v-else-if="showBackToEvent"
          aria-label="go back to event page"
          href="javascript:void(0)"
          class="back-to-search-link linkified"
          @click="goBackToEventPage"
        >
          <span><svg-white-arrow-left class="mr-1"></svg-white-arrow-left> Back to
            event</span>
        </a>
      </div>
    </div>
    <div v-if="organisation">
      <div class="white-background-section">
        <div class="container profile-card-container">
          <el-card class="profile-card">
            <div class="profile-card-body pb-0">
              <el-row>
                <el-col
                  :xs="5"
                  :sm="5"
                  :md="5"
                  :lg="4"
                >
                  <el-avatar
                    shape="circle"
                    class="avatar"
                    :src="organisation.profile_photo"
                    :alt="`${
                      organisation ? organisation.name : ''
                    } Profile picture`"
                  >
                    <img src="../../../static/img/default-image.png" />
                  </el-avatar>
                </el-col>
                <el-col
                  id="main-content"
                  :xs="19"
                  :sm="19"
                  :md="19"
                  :lg="13"
                >
                  <div class="user-info">
                    <div class="d-flex justify-content-between">
                      <h1>{{ organisation.name }}</h1>
                      <div
                        class="followers-section d-flex hidden-md-and-down"
                      ></div>
                    </div>

                    <div class="location d-flex">
                      <a
                        :href="organisation.website_address"
                        target="_blank"
                      >{{
                        organisation.website_address
                      }}</a>
                      <div class="d-none d-md-block">
                        <svg-vertical-line
                          class="vertical-line"
                          aria-labeledby="vertical line"
                        ></svg-vertical-line>
                      </div>
                      <a :href="`mailto:${organisation.email}`">{{
                        organisation.email
                      }}</a>
                    </div>

                    <div>
                      <p class="pt-4">
                        Member, {{ memberFor }}
                      </p>
                    </div>
                  </div>
                </el-col>
                <el-col
                  :xs="24"
                  :sm="24"
                  :md="24"
                  :lg="7"
                >
                  <!--div class="followers-section d-flex justify-content-end">
                    <p
                      v-if="isOrganisationOwner"
                      class="clickable"
                      @click="$router.push({ name: 'Following' })"
                    >
                      <span>{{ organisation.following_count }}</span> Following
                    </p>
                    <div
                      v-if="isOrganisationOwner"
                      class="separator"
                    >
                      |
                    </div>
                    <p
                      :class="{ clickable: isOrganisationOwner }"
                      @click="
                        isOrganisationOwner
                          ? $router.push({ name: 'Followers' })
                          : null
                      "
                    >
                      <span>{{ organisation.followers_count }}</span>
                      {{
                        organisation.followers_count > 1
                          ? "Followers"
                          : "Follower"
                      }}
                    </p>
                  </!--div-->
                </el-col>
              </el-row>
            </div>
            <el-row>
              <el-col :md="24">
                <div class="profile-card-actions-container">
                  <div class="profile-card-actions">
                    <el-button
                      v-if="isOrganisationOwner"
                      type="primary"
                      @click="editProfile"
                    >
                      Edit profile
                    </el-button>
                    <el-button
                      v-if="isOrganisationOwner"
                      type="button"
                      @click="inviteMembers()"
                    >
                      Invite Members
                    </el-button>
                    <el-button
                      type="button"
                      :disabled="loadingMembers"
                      :loading="loadingMembers"
                      @click="fetchOrganisationMembers()"
                    >
                      View Members
                    </el-button>
                    <!--el-button
                      v-if="!isOrganisationOwner"
                      v-loading="startAction"
                      type="button"
                      @click="followUnfollowOrganisation()"
                    >
                      {{ organisation.has_followed ? "Unfollow" : "Follow" }}
                    </!--el-button-->
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-card>
        </div>
        <div class="container main-content">
          <el-row>
            <el-col :lg="12">
              <div class="about-section">
                <h1>
                  About {{ isOrganisationOwner ? "you" : organisation.name }}
                </h1>
                <p>{{ organisation.about_organisation }}</p>
              </div>
              <div>
                <p class="font-weight-bold py-3">
                  Localities
                </p>
                <p
                  v-for="(locality, index) in localities"
                  :key="index"
                  class="pb-2"
                >
                  {{ locality.name }}
                </p>
              </div>
            </el-col>
            <el-col :lg="12">
              <div class="about-section">
                <organisation-map-view
                  v-if="organisation.address"
                  :address="organisation.address"
                  :api-key="googleMapKey"
                  :map-config="mapConfig"
                />
              </div>
            </el-col>
          </el-row>
          <hr class="content-separator" />
          <el-row>
            <el-col
              :sm="24"
              :md="12"
            >
              <h1>Services</h1>
              <div class="w-100">
                <div
                  v-for="(service, index) in services"
                  :key="index"
                  class="tag-container"
                >
                  {{ service.name }}
                </div>
              </div>
            </el-col>
          </el-row>
          <hr class="content-separator" />
          <el-row v-loading="loadingMembers">
            <el-col
              :sm="24"
              :md="18"
            >
              <h1 class="font-weight-bold py-3 d-flew flex-column">
                Members ({{ organisation.members_count }})
                <span
                  class="button-link"
                  @click="fetchOrganisationMembers"
                > View all </span>
              </h1>
              <mini-member-card
                :member="ownerMember"
                :is-owner="true"
              />
              <mini-member-card
                v-for="(member, index) in members"
                :key="index"
                :member="member"
                :is-owner="false"
              />
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <focus-lock>
      <el-dialog
        ref="memberstConfirmDialog"
        :show-close="false"
        custom-class="request-success-modal"
        :visible.sync="membersDialogVisible"
        @opened="dialogOpen('memberstConfirmDialog')"
      >
        <div class="success-dialog">
          <mini-member-card
            v-for="(member, index) in organisationMembers"
            :key="index"
            :member="member"
            :is-owner="member.id == organisation.owner.id"
          />
        </div>
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            class="mx-auto"
            @click="membersDialogVisible = false"
          >
            Close
          </el-button>
        </span>
      </el-dialog>
    </focus-lock>
    <member-invitation-dialog
      :visible="invitationDialogVisible"
      @close="invitationDialogVisible = false"
    />
  </div>
</template>

<script>
import store from "@/store";
import { mapGetters, mapState } from "vuex";
import gsApi from "@/services/gs.api";
import WhiteArrowLeft from "@/components/assets/svg-white-arrow-left";
import VerticalLine from "@/components/assets/svg-vertical-line";
import enumHelper from "@/helpers/enumHelper";
import MiniMemberCard from "@/components/platform/members/mini-member-card";
import OrganisationMapView from "@/components/platform/organisations/organisation-map-view";
import MemberInvitationDialog from "@/components/platform/organisations/member-invitation-dialog";
import { mapOrganisationConfig } from '@/components/map-view/config/map-config'

export default {
  name: "OrganisationProfile",
  metaInfo: {
    title: "Organisation profile",
  },
  components: {
    "svg-white-arrow-left": WhiteArrowLeft,
    "svg-vertical-line": VerticalLine,
    MiniMemberCard,
    OrganisationMapView,
    MemberInvitationDialog
  },
  data() {
    return {
      enumHelper,
      startAction: false,
      isGlobalScotViewing: false,
      isOrganisationOwner: false,
      organisation: null,
      mainLoader: true,
      loadingMembers: false,
      showBackToSearch: false,
      membersDialogVisible: false,
      organisationMembers: [],
      invitationDialogVisible: false,
    };
  },
  computed: {
    ...mapState(["user"]),
    ...mapGetters(["navigatedFrom"]),
    memberFor() {
      return this.organisation?.owner?.expertProfile?.joined_at_for_humain
    },
    showBackToEvent() {
      return (
        this.navigatedFrom.name && this.navigatedFrom.name === "event-view"
      );
    },
    localities() {
      return this.organisation?.localities
        ? this.organisation.localities.data
        : [];
    },
    services() {
      return this.organisation?.services ? this.organisation.services.data : [];
    },
    members() {
      return this.organisation.members ? this.organisation.members.data : [];
    },
    ownerMember(){
      return {
        avatar: this.organisation.owner.avatar,
        full_name: this.organisation.owner.full_name,
        role: this.organisation.owner.expertProfile.role,
        organisation_name: this.organisation.owner.expertProfile.organisation_name,
        id: this.organisation.owner.id,
      }
    },
    directMessagesPaused() {
      const settings = this.organisation.owner.expertProfile.settings;
      return (
        settings !== null &&
        Object.prototype.hasOwnProperty.call(
          settings,
          "direct_messages_paused_at"
        ) &&
        settings.direct_messages_paused_at !== null
      );
    },
    googleMapKey() {
      return process.env.VUE_APP_GOOGLE_MAP_KEY
    },
    mapConfig() {
      return {
        ...mapOrganisationConfig,
        center: this.organisation.address ? {lat: parseFloat(this.organisation.address.latitude) , lng: parseFloat(this.organisation.address.longitude) } : {lat: 0, lng: 0}
      }
    },
  },
  watch: {
    $route(to, from) {
      if (from.path !== to.path && this.user.isLogged) {
        this.mainLoader = true;
        this.fetchOrganisationProfile();
      }
    },
  },
  created() {
    if (this.$route.params.showBackToSearch) {
      this.showBackToSearch = true;
    }

    if (store.state.user.isLogged) {
      this.fetchOrganisationProfile();
    }
  },
  beforeDestroy() {
    this.$store.dispatch("updateNavigatedFrom", {
      name: null,
    });
  },
  methods: {
    inviteMembers() {
      this.invitationDialogVisible = true;
    },
    editProfile() {
      this.$router.push({ name: "Organisation Details" });
    },
    fetchOrganisationProfile() {
      gsApi.organisation
        .profile(this.$route.params.id)
        .then((response) => {
          this.mainLoader = false;
          const owner = response.data.owner;
          if (!owner.expertProfile || !owner.roles.includes("expert")) {
            this.$alert(
              "Unable to load oganisation profile. Please try again later.",
              "Error",
              {
                confirmButtonText: "Close",
                showClose: false,
                customClass: "notification-modal",
              }
            );
            this.$router.push({
              name: "Members",
              params: { sortBy: "Organisation" },
            });
          } else if (owner.suspended) {
            this.$alert("Organisation is not currently active.", "Error", {
              confirmButtonText: "Close",
              showClose: false,
              customClass: "notification-modal",
            });
            this.$router.push({
              name: "Members",
              params: { sortBy: "Organisation" },
            });
          } else {
            this.organisation = response.data;
            this.checkRole();
          }
        })
        .catch((ex) => {
          console.log(ex)
          this.mainLoader = false;
          this.$alert(
            "Unable to load Organisation profile. Please try again later.",
            "Error",
            {
              confirmButtonText: "Close",
              showClose: false,
              customClass: "notification-modal",
            }
          );
          this.$router.push({
            name: "Members",
            params: { sortBy: "Organisation" },
          });
        });
    },
    checkRole() {
      this.isGlobalScotViewing = false;

      if (this.user.id !== this.$route.params.id) {
        this.isGlobalScotViewing = true;
      }

      if (this.user.id == this.organisation?.owner?.id) {
        this.isOrganisationOwner = true;
        return;
      }
    },
    followUnfollowOrganisation() {
      this.startAction = true;
      let action = this.member.has_followed
        ? enumHelper.FollowAction.UNFOLLOW
        : enumHelper.FollowAction.FOLLOW;
      const data = {
        id: this.$route.params.id,
        module: "User",
        entity: "User",
      };
      gsApi.followable
        .followUnfollow(data, action)
        .then((response) => {
          this.member.has_followed = response.data.has_followed;
          this.member.followers_count = response.data.followers_count;
          if (action == enumHelper.FollowAction.FOLLOW) {
            this.$alert(
              `Your are now successfully following ${this.member.full_name}.`,
              "Success",
              {
                confirmButtonText: "Close",
                showClose: false,
                customClass: "notification-modal",
              }
            );
          } else {
            this.$alert(
              `Your have successfully unfollowed ${this.member.full_name}.`,
              "Success",
              {
                confirmButtonText: "Close",
                showClose: false,
                customClass: "notification-modal",
              }
            );
          }
        })
        .catch((response) => {
          if (response.status == 422) {
            let firstError =
              response.data.errors[Object.keys(response.data.errors)[0]];
            this.$alert(firstError[0], "Error", {
              confirmButtonText: "Close",
              showClose: false,
              customClass: "notification-modal",
            });
          } else {
            this.$alert(
              "Sorry, your request could not be processed",
              `Error ${error.response.data.error.status_code} - ${error.response.data.error.message}`,
              {
                confirmButtonText: "Close",
                showClose: false,
                customClass: "notification-modal",
              }
            );
          }
        })
        .finally(() => {
          this.startAction = false;
        });
    },
    goBackToEventPage() {
      this.$router.go(-1);
    },
    fetchOrganisationMembers() {
      this.loadingMembers = true;
      gsApi.organisation
        .members(this.organisation.id)
        .then((response) => {
          this.organisationMembers = response.data?.data;
          this.membersDialogVisible = true;
        })
        .catch(() => {
          this.$alert(
            "Unable to load Organisation members. Please try again later.",
            "Error",
            {
              confirmButtonText: "Close",
              showClose: false,
              customClass: "notification-modal",
            }
          );
        })
        .finally(() => {
          this.loadingMembers = false;
        });
    },
  },
};
</script>
<style lang="scss">
.vertical-line {
  top: 4px;
  margin-top: 0px !important;
  margin: 0 10px !important;
  position: relative;
  height: 18px;
}
</style>
